import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { queryKeys } from './queryKeys';
import type { Tables } from '@/integrations/supabase/types';

export type Goal = Tables<'financial_goals'>;

/**
 * Fetch all financial goals
 * Used by: Goals page, Planning page, Wellness insights
 */
export function useGoals() {
  return useQuery({
    queryKey: queryKeys.goals.list(),
    queryFn: async () => {
      const { data, error } = await supabase
        .from('financial_goals')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return (data || []) as Goal[];
    },
    staleTime: 1000 * 60 * 10,
  });
}
